import { Observable } from 'rxjs';
import { Socio } from '../../../domain/models/socio.model';
import { Retrieve } from '../../../domain/repositories/general/retrieve.interface';
import { CRUDHnadler } from '../../../domain/repositories/general/crud.handler';

/**
 *Casos de uso de la entidad Socio que realizara acciones a nivel de aplicación cuando se realice la acción de recuperación 

 *
 * @export
 * @class RetrieveSocioUseCase
 * @implements {Retrieve}
 */
export class RetrieveSocioUseCase implements Retrieve {
  constructor(private crudHandler: CRUDHnadler) {}

  public get(id: number): Observable<Socio> {
    return this.crudHandler.findById(id);
  }

  public getAll(): Observable<Socio[]> {
    return this.crudHandler.findAll();
  }
}
